import React from "react";
import { withTranslation } from "react-i18next";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import home from "../Home/Home";
import isIE from '../../utils/ie';
import UnsupportedBrowser from '../UnsupportedBrowser/UnsupportedBrowser';

const HomeComponent = isIE() ? UnsupportedBrowser : home;

class App extends React.Component {

  render(){
    return (
      <Router>
          <Routes>
            <Route path="/:localeName" element={<HomeComponent />} />
            <Route path="/" element={<HomeComponent />} />
          </Routes>
      </Router>
    );
  }
}

export default withTranslation()(App);